module.exports = __webpack_public_path__ + "static/media/itbc.4b924e26.svg";